export const es = {
  "BACK_BUTTON": "Volver",
  "NEXT_BUTTON": "Siguiente",
  "I_AGREE": "De acuerdo",
  "FINISH_BUTTON": "Terminar",
  "CHOICES_TITLE": "Respuesta",
  "SELECT_INPUT": "Nombre",
  "MULTICHOICE_PEER_PLACEHOLDER": "Selecciona persona(s)",
  "MULTICHOICE_PEER_REQUIRED_ERROR": "Selecciona al menos una persona.",
  "MULTICHOICE_OTHER_LABEL": "Otro (especifique)",
  "MULTICHOICE_OTHER_PLACEHOLDER": "Especifique",
  "MULTICHOICE_OTHER_TEXT_REQUIRED": "Especifique su respuesta para \"Otro\".",
  "MULTICHOICE_OTHER_TEXT_TOO_LONG": "Su respuesta debe tener 1000 caracteres o menos.",
  "MULTICHOICE_CLEAR_SELECTION": "Borrar selección",
  "LIKERT_HINT": "Selecciona una persona y asigna una puntuación.",
  "LIKERT_SCORE_LABEL": "Puntuación",
  "LIKERT_INCOMPLETE_ERROR": "Selecciona persona y puntuación en cada fila.",
  "LIKERT_INVALID_ERROR": "Una o más puntuaciones están fuera del rango permitido.",
  "EMPTY_ERROR": "Selecciona al menos una opción de respuesta",
    "SUBMIT_ERROR": "No se pudieron enviar las respuestas. Revisa tus respuestas.",
  "SENDING_DATA": "datos enviados!",
  "LOADING": "Cargando...",
  "MAX_SELECT_ERROR": "Límite máximo es",
  "FORM_ALREADY_ANSWERED": "Gracias por tu participación. Tus resultados se han enviado correctamente.",
  "MAX_SELECT_CUSTOM_MESSAGE": "Ha alcanzado el valor máximo de la opción",
  "SKILL_PLACEHOLDER": "Herramientas/conocimientos",
  "QR_SELECT_TITLE": "Selecciona tu nombre",
  "QR_SELECT_PLACEHOLDER": "Busca tu nombre...",
  "QR_NO_PARTICIPANTS": "No hay participantes disponibles. Todos los participantes ya han respondido.",
  "QR_SURVEY_NOT_FOUND": "Encuesta no encontrada",
  "QR_LOAD_ERROR": "No se pueden cargar los participantes. Por favor, inténtalo de nuevo.",
  "QR_PARTICIPANT_ALREADY_ANSWERED": "Este participante ya ha completado la encuesta. Por favor, vuelve a seleccionar tu nombre.",
  "QR_BACK_TO_SELECTION": "Volver a selección de nombre",
  "companyValues": {
    "PASSION": "Pasión por todo lo que hacemos",
    "INNOVATING": " Siempre innovando",
    "CONFIDENCE": "Con confianza y responsabilidad",
    "WINNING": "Ganando en equipo",
    "DIFFERENCE": "Comprometidos para marcar la diferencia"
  },
  "THANK_YOU": "Gracias por su participación en la encuesta de Análisis de Redes Organizacionales (ONA). Sus comentarios han sido enviados."
}